module.exports = __webpack_public_path__ + "static/media/LineFace.7df43977.svg";